import { render, staticRenderFns } from "./WhatNewCard.vue?vue&type=template&id=f3a26838&scoped=true"
import script from "./WhatNewCard.vue?vue&type=script&lang=js"
export * from "./WhatNewCard.vue?vue&type=script&lang=js"
import style0 from "./WhatNewCard.vue?vue&type=style&index=0&id=f3a26838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a26838",
  null
  
)

export default component.exports